import { HttpClient } from "@angular/common/http";
import { Injectable } from '@angular/core';

// Custom
import { HttpService } from "src/app/core/data/service/http.service";
import { Dictionary } from 'src/app/shared/helpers/util';
import { HelpText } from '../schema/help-text';

@Injectable({
  providedIn: 'root'
})
export class HelpTextService extends HttpService {

  private helpDic: Dictionary<string>;
  private lastFetch: number;
  private refreshPeriod: number = 1000 * 60 * 60;

  constructor(http: HttpClient) {
    super(http);

    this.endpoint = `${this.apiURL}/helptext`;
  }

  async fetchHelpText(pageKey: string) {
    try {
      // refresh if dictionary hasn't been created, key isn't found, or 5 minutes have passed
      if (this.helpDic == null || this.helpDic[pageKey] == null || new Date().getTime() - this.lastFetch > this.refreshPeriod) { //(1000 * 60 * 60 * 1) ) {
        this.lastFetch = new Date().getTime();
        var response = (await super.fetch(`${this.endpoint}/`) as HelpText[]).map(m => new HelpText(m));
        this.helpDic = {};
        response.forEach(h => {
          this.helpDic[h.pageKey] = h.htmlContent;
        });
      }
      return this.helpDic[pageKey];
    } catch (error) {
      console.error('Error fetching starting resources. Error: ', error);
      throw error;
    }
  }


  protected isUpdate(entity: any) {
    return (entity.helpTextId != null);
  }

  protected getUpdateUrl(entity: any) {
    return `${this.endpoint}/${entity.helpTextId}`;
  }
}
